<split-steps #steps (stepChange)="onActiveIndexChanged($event)">


    <split-step [passo]="0">
        <section class="pb-6">

            <div class="flex flex-column mt-3">
                <div class="flex justify-content-between align-items-center h-3rem p-4 border-round-top-lg"
                    style="background-color: #F5F5F5; color: #585050">
                    <h6 class="text-xs">Tipo</h6>
                    <div class="flex justify-content-center align-items-center w-8rem h-2rem">
                        <h6 class="text-xs">Liberação</h6>
                    </div>
                </div>
                <div class="flex flex-column ">
                    <div class="h-5rem flex justify-content-between align-items-center px-4"
                        style="border-bottom: 1px solid #DDD;">
                        <h4 class="title-text">
                            Pessoa Física
                        </h4>

                        <button [ngClass]="contabilidadeSelecionada == 'pessoa-fisica'? 'button-selected' : '' "
                            (click)="selecionarContabilidade('pessoa-fisica')"
                            class="button flex justify-content-center align-items-center w-8rem h-2rem border-round-md">

                            <span *ngIf="contabilidadeSelecionada == 'pessoa-fisica'; else selecionar">
                                Selecionado
                            </span>

                            <ng-template #selecionar>
                                Selecionar
                            </ng-template>
                        </button>

                    </div>

                    <div class="h-5rem flex justify-content-between align-items-center px-4"
                        style="border-bottom: 1px solid #DDD;">
                        <h4 class="title-text">
                            Pessoa Jurídica
                        </h4>

                        <button [ngClass]="contabilidadeSelecionada == 'pessoa-juridica'? 'button-selected' : '' "
                            (click)="selecionarContabilidade('pessoa-juridica')"
                            class="button flex justify-content-center align-items-center w-8rem h-2rem border-round-md">
                            <span *ngIf="contabilidadeSelecionada == 'pessoa-juridica'; else selecionar">
                                Selecionado
                            </span>

                            <ng-template #selecionar>
                                Selecionar
                            </ng-template>
                        </button>

                    </div>

                    <div class="h-5rem flex justify-content-between align-items-center px-4"
                        style="border-bottom: 1px solid #DDD;">
                        <h4 class="title-text">
                            Pessoa Jurídica emissão automática NF
                        </h4>

                        <button
                            [ngClass]="contabilidadeSelecionada == 'pj-emissao-automatica-nf'? 'button-selected' : '' "
                            (click)="selecionarContabilidade('pj-emissao-automatica-nf')"
                            class="button flex justify-content-center align-items-center w-8rem h-2rem border-round-md">
                            <span *ngIf="contabilidadeSelecionada == 'pj-emissao-automatica-nf'; else selecionar">
                                Selecionado
                            </span>

                            <ng-template #selecionar>
                                Selecionar
                            </ng-template>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    </split-step>

    <split-step [passo]="1">
        <ng-container *ngIf="contabilidadeSelecionada === 'pessoa-fisica'">
            <form [formGroup]="form" class="pb-6 flex flex-column">
                <span class="text-xs mb-5 tipo-contabilidade">Cadastro para recebimento em Pessoa Física</span>
                <span class="text-xs flex align-items-center texto-info">
                    <p-checkbox class="mr-2" [binary]="true" inputId="binary"></p-checkbox>
                    Estou ciente que irei receber em minha pessoa física e Split Pay não se responsabiliza pelo método
                    escolhido
                </span>
            </form>
        </ng-container>

        <ng-container *ngIf="contabilidadeSelecionada === 'pessoa-juridica'">
            <form [formGroup]="form" class="pb-5 flex flex-column">
                <span class="text-xs mb-4 tipo-contabilidade">Cadastro para recebimento em Pessoa Jurídica</span>
                <div class="flex align-items-center mb-4">
                    <p-inputSwitch split-switch-small class="-ml-2" formControlName="socioAdministrador"
                        (onChange)="ativarSocioAdministrador()"></p-inputSwitch>
                    <span class="label-switch -ml-1 texto-info">Sou sócio administrador</span>
                </div>

                <ng-container *ngIf="socioAdiministradorContabilidade">

                    <div class="grid p-fluid mb-4">


                        <div class="col-6 mb-3">

                            <span class="p-float-label">
                                <input pInputText id="cnpj" />
                                <label htmlFor="cnpj" class="text-xs pl-2">CNPJ</label>
                            </span>

                        </div>

                        <div class="col-6 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="razao-social" />
                                <label htmlFor="razao-social" class="text-xs pl-2">Razão Social</label>
                            </span>

                        </div>


                        <div class="col-6 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="email-contabilidade" />
                                <label htmlFor="email-contabilidade" class="text-xs pl-2">Email Contabilidade</label>
                            </span>
                        </div>



                        <div class="col-6 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="codigo-servico-profissional" />
                                <label htmlFor="codigo-servico-profissional"
                                    class="text-xs pl-2 h-1rem flex align-items-center">
                                    Código de Serviço Profissional
                                    <img class="ml-1" src="assets\cadastrar-profissionais\alerta-campo-vazio.svg"
                                        alt="alerta-campo-vazio">

                                </label>
                            </span>
                        </div>



                    </div>

                    <span class="text-xs flex align-items-center texto-info">
                        <p-checkbox class="mr-2" [binary]="true" inputId="binary"></p-checkbox>
                        Estou ciente que irei receber em minha pessoa jurídica e Split Pay não se responsabiliza pelo
                        método
                        escolhido
                    </span>

                </ng-container>

                <ng-container *ngIf="!socioAdiministradorContabilidade">

                    <div class="grid p-fluid mb-4">

                        <div class="col-6 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="nome-completo" />
                                <label htmlFor="nome-completo" class="text-xs pl-2">Nome Completo</label>
                            </span>
                        </div>

                        <div class="col-6 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="telefone-socio" />
                                <label htmlFor="telefone-socio" class="text-xs pl-2">Telefone Sócio</label>
                            </span>
                        </div>




                        <div class="col-4 mb-3 ">
                            <span class="p-float-label">
                                <input pInputText id="cpf" />
                                <label htmlFor="cpf" class="text-xs pl-2">CPF</label>
                            </span>
                        </div>

                        <div class="col-4 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="rg" />
                                <label htmlFor="rg" class="text-xs pl-2">RG</label>
                            </span>
                        </div>

                        <div class="col-4 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="data-nascimento" />
                                <label htmlFor="data-nascimento" class="text-xs pl-2">Data de Nascimento</label>
                            </span>
                        </div>



                        <div class="col-6 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="nome-mae" />
                                <label htmlFor="nome-mae" class="text-xs pl-2">Nome da Mãe</label>
                            </span>
                        </div>

                        <div class="col-6 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="email-contabilidade" />
                                <label htmlFor="email-contabilidade" class="text-xs pl-2">Email Contabilidade</label>
                            </span>
                        </div>



                        <div class="col-4 mb-2">
                            <span class="p-float-label">
                                <input pInputText id="cnpj" />
                                <label htmlFor="cnpj" class="text-xs pl-2">CNPJ</label>
                            </span>
                        </div>

                        <div class="col-4 mb-2">
                            <span class="p-float-label">
                                <input pInputText id="razao-social" />
                                <label htmlFor="razao-social" class="text-xs pl-2">Razão Social</label>
                            </span>
                        </div>

                        <div class="col-4 mb-2">
                            <span class="p-float-label">
                                <input pInputText id="codigo-servico-profissional" />
                                <label htmlFor="codigo-servico-profissional"
                                    class="text-xs pl-2 h-1rem flex align-items-center">
                                    Código de Serviço Profissional
                                    <img class="ml-1" src="assets\cadastrar-profissionais\alerta-campo-vazio.svg"
                                        alt="alerta-campo-vazio">

                                </label>
                            </span>
                        </div>

                    </div>



                    <span class="text-xs flex align-items-center texto-info">
                        <p-checkbox class="mr-2" [binary]="true" inputId="binary"></p-checkbox>
                        Estou ciente que irei receber em minha pessoa jurídica e Split Pay não se responsabiliza pelo
                        método escolhido
                    </span>
                </ng-container>
            </form>
        </ng-container>

        <ng-container *ngIf="contabilidadeSelecionada === 'pj-emissao-automatica-nf'">
            <form [formGroup]="form" class="pb-5 flex flex-column">
                <span class="text-xs mb-4 tipo-contabilidade">Cadastro para recebimento em Pessoa Jurídica com emissão
                    de NF automática</span>
                <div class="flex align-items-center mb-4">
                    <p-inputSwitch split-switch-small class="-ml-2" formControlName="socioAdministrador"
                        (onChange)="ativarSocioAdministrador()"></p-inputSwitch>
                    <span class="label-switch -ml-1 texto-info">Sou sócio administrador</span>
                </div>

                <ng-container *ngIf="socioAdiministradorContabilidade">
                    <div class="grid p-fluid mb-4">


                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="cnpj" />
                                <label htmlFor="cnpj" class="text-xs pl-2">CNPJ</label>
                            </span>
                        </div>


                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="razao-social" />
                                <label htmlFor="razao-social" class="text-xs pl-2">Razão Social
                                </label>
                            </span>
                        </div>

                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="nome-fantasia" />
                                <label htmlFor="nome-fantasia" class="text-xs pl-2">Nome Fantasia
                                </label>
                            </span>
                        </div>

                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="natureza-juridica" />
                                <label htmlFor="natureza-juridica" class="text-xs pl-2">Natureza Jurídica</label>
                            </span>
                        </div>

                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="regime-tributario" />
                                <label htmlFor="regime-tributario" class="text-xs pl-2">Regime Tributário</label>
                            </span>
                        </div>


                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="inscricao-estadual" />
                                <label htmlFor="inscricao-estadual" class="text-xs pl-2">Inscrição Estadual
                                </label>
                            </span>
                        </div>


                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="inscricao-municipal" />
                                <label htmlFor="inscricao-municipal" class="text-xs pl-2">Inscrição Municipal
                                </label>
                            </span>
                        </div>

                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="aliquota-iss-simples" />
                                <label htmlFor="aliquota-iss-simples" class="text-xs pl-2">Alíquota ISS Simples</label>
                            </span>
                        </div>

                        <div class="col-6 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="cep" />
                                <label htmlFor="cep" class="text-xs pl-2">CEP</label>
                            </span>
                        </div>
                        <div class="col-6 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="logradouro" />
                                <label htmlFor="logradouro" class="text-xs pl-2">Logradouro</label>
                            </span>
                        </div>


                        <div class="col-4 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="numero" />
                                <label htmlFor="numero" class="text-xs pl-2">Número</label>
                            </span>
                        </div>

                        <div class="col-4 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="complemento" />
                                <label htmlFor="complemento" class="text-xs pl-2">Complemento
                                </label>
                            </span>
                        </div>

                        <div class="col-4 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="bairro" />
                                <label htmlFor="bairro" class="text-xs pl-2">Bairro
                                </label>
                            </span>
                        </div>



                        <div class="col-4 mb-3">
                            <span class="p-float-label">
                                <p-dropdown [options]="listaEstados" [autoDisplayFirst]="false" optionLabel="nome"
                                    inputId="float-label">
                                </p-dropdown>
                                <label class="text-xs pl-2 h-1rem flex align-items-center" for="float-label">
                                    Estado
                                </label>
                            </span>
                        </div>

                        <div class="col-4 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="cidade" />
                                <label htmlFor="cidade" class="text-xs pl-2">Cidade
                                </label>
                            </span>
                        </div>


                        <div class="col-4 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="email-contabilidade" />
                                <label htmlFor="email-contabilidade" class="text-xs pl-2">Email Contabilidade
                                </label>
                            </span>
                        </div>




                        <div class="col-4 mb-2">
                            <span class="p-float-label">
                                <input pInputText id="codigo-servico-profissional" />
                                <label htmlFor="codigo-servico-profissional"
                                    class="text-xs pl-2 h-1rem flex align-items-center">
                                    Código de Serviço Profissional
                                    <img class="ml-1" src="assets\cadastrar-profissionais\alerta-campo-vazio.svg"
                                        alt="alerta-campo-vazio">

                                </label>
                            </span>
                        </div>


                        <div class="col-4 mb-2">
                            <span class="p-float-label">
                                <input pInputText id="senha-certificado-digital" />
                                <label htmlFor="senha-certificado-digital" class="text-xs pl-2">Senha Certificado
                                    Digital
                                </label>
                            </span>
                        </div>

                        <div class="col-4 mb-2">
                            <input class="upload" type="file" id="certificado-digital"
                                placeholder="Certificado Digital A1" style="display: none;">
                            <label class="upload flex justify-content-between" for="certificado-digital">Certificado
                                Digital A1
                                <img src="assets\cadastrar-unidade\upload.svg" alt="upload-certificado-digital">
                            </label>
                        </div>


                    </div>

                    <span class="text-xs flex align-items-center texto-info">
                        <p-checkbox class="mr-2" [binary]="true" inputId="binary"></p-checkbox>
                        Estou ciente que irei receber em minha pessoa jurídica e Split Pay não se responsabiliza
                        pelo
                        método escolhido
                    </span>
                </ng-container>

                <ng-container *ngIf="!socioAdiministradorContabilidade">

                    <div class="grid p-fluid mb-4">

                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="cnpj" />
                                <label htmlFor="cnpj" class="text-xs pl-2">CNPJ</label>
                            </span>
                        </div>

                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="razao-social" />
                                <label htmlFor="razao-social" class="text-xs pl-2">Razão Social
                                </label>
                            </span>
                        </div>
                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="nome-fantasia" />
                                <label htmlFor="nome-fantasia" class="text-xs pl-2">Nome Fantasia
                                </label>
                            </span>
                        </div>

                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="natureza-juridica" />
                                <label htmlFor="natureza-juridica" class="text-xs pl-2">Natureza Jurídica</label>
                            </span>
                        </div>


                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="regime-tributario" />
                                <label htmlFor="regime-tributario" class="text-xs pl-2">Regime Tributário</label>
                            </span>
                        </div>

                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="inscricao-estadual" />
                                <label htmlFor="inscricao-estadual" class="text-xs pl-2">Inscrição Estadual
                                </label>
                            </span>
                        </div>

                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="inscricao-municipal" />
                                <label htmlFor="inscricao-municipal" class="text-xs pl-2">Inscrição Municipal
                                </label>
                            </span>
                        </div>

                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="aliquota-iss-simples" />
                                <label htmlFor="aliquota-iss-simples" class="text-xs pl-2">Alíquota ISS Simples</label>
                            </span>
                        </div>





                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="cep" />
                                <label htmlFor="cep" class="text-xs pl-2">CEP</label>
                            </span>
                        </div>
                        <div class="col-6 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="logradouro" />
                                <label htmlFor="logradouro" class="text-xs pl-2">Logradouro
                                </label>
                            </span>
                        </div>

                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="numero" />
                                <label htmlFor="numero" class="text-xs pl-2">Número
                                </label>
                            </span>
                        </div>




                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="complemento" />
                                <label htmlFor="complemento" class="text-xs pl-2">Complemento</label>
                            </span>
                        </div>

                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="bairro" />
                                <label htmlFor="bairro" class="text-xs pl-2">Bairro
                                </label>
                            </span>
                        </div>

                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <p-dropdown [options]="listaEstados" [autoDisplayFirst]="false" optionLabel="nome"
                                    inputId="float-label">
                                </p-dropdown>
                                <label class="text-xs pl-2 h-1rem flex align-items-center" for="float-label">
                                    Estado
                                </label>
                            </span>
                        </div>


                        <div class="col-3 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="cidade" />
                                <label htmlFor="cidade" class="text-xs pl-2">Cidade</label>
                            </span>
                        </div>



                        <div class="col-6 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="email-contabilidade" />
                                <label htmlFor="email-contabilidade" class="text-xs pl-2">Email Contabilidade</label>
                            </span>
                        </div>

                        <div class="col-6 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="nome-completo-socio-adm" />
                                <label htmlFor="nome-completo-socio-adm" class="text-xs pl-2">Nome Completo (Sócio Adm)
                                </label>
                            </span>
                        </div>




                        <div class="col-4 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="cpf-socio-adm" />
                                <label htmlFor="cpf-socio-adm" class="text-xs pl-2">CPF (Sócio Adm)</label>
                            </span>
                        </div>


                        <div class="col-4 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="rg-socio-adm" />
                                <label htmlFor="rg-socio-adm" class="text-xs pl-2">RG (Sócio Adm)
                                </label>
                            </span>
                        </div>

                        <div class="col-4 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="data-nascimento-socio-adm" />
                                <label htmlFor="data-nascimento-socio-adm" class="text-xs pl-2">Data de Nascimento
                                    (Sócio
                                    Adm)
                                </label>
                            </span>
                        </div>




                        <div class="col-4 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="nome-da-mae-socio-adm" />
                                <label htmlFor="nome-da-mae-socio-adm" class="text-xs pl-2">Nome da Mãe (Sócio
                                    Adm)</label>
                            </span>
                        </div>

                        <div class="col-4 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="email-socio-adm" />
                                <label htmlFor="email-socio-adm" class="text-xs pl-2">Email (Sócio Adm)
                                </label>
                            </span>
                        </div>

                        <div class="col-4 mb-3">
                            <span class="p-float-label">
                                <input pInputText id="telefone-socio-adm" />
                                <label htmlFor="telefone-socio-adm" class="text-xs pl-2">Telefone (Sócio Adm)
                                </label>
                            </span>
                        </div>




                        <div class="col-4 mb-2">
                            <span class="p-float-label">
                                <input pInputText id="codigo-servico-profissional" />
                                <label htmlFor="codigo-servico-profissional"
                                    class="text-xs pl-2 h-1rem flex align-items-center">
                                    Código de Serviço Profissional
                                    <img class="ml-1" src="assets\cadastrar-profissionais\alerta-campo-vazio.svg"
                                        alt="alerta-campo-vazio">

                                </label>
                            </span>
                        </div>

                        <div class="col-4 mb-2">
                            <span class="p-float-label">
                                <input pInputText id="senha-certificado-digital" />
                                <label htmlFor="senha-certificado-digital" class="text-xs pl-2">Senha Certificado
                                    Digital
                                </label>
                            </span>
                        </div>

                        <div class="col-4 mb-2">

                            <input class="upload" type="file" id="certificado-digital"
                                placeholder="Certificado Digital A1" style="display: none;">
                            <label class="upload flex justify-content-between" for="certificado-digital">Certificado
                                Digital A1
                                <img src="assets\cadastrar-unidade\upload.svg" alt="upload-certificado-digital">
                            </label>


                        </div>

                    </div>

                    <span class="text-xs flex align-items-center texto-info">
                        <p-checkbox class="mr-2" [binary]="true" inputId="binary"></p-checkbox>
                        Estou ciente que irei receber em minha pessoa jurídica e Split Pay não se responsabiliza
                        pelo
                        método escolhido
                    </span>
                </ng-container>
            </form>
        </ng-container>

    </split-step>

    <ng-template #customNextButton *ngIf="steps.activeIndex == 2">
        <!-- <button class="s-step__button-next" (click)="steps.nextStep()">Salvar</button> -->


        <button class="flex ml-auto" split-botao [botao]="{
    titulo: 'finalizar',
    rota: '/cadastro/profissionais',
    rightIcon: 'pi-check',
    estilo: 'laranja',


  }"></button>


    </ng-template>

</split-steps>